export const INTROSEEN = "hasSeenIntrodution";

export const GETQUERY = "getDataFromQuery";
export const ERRORFETCHER = "handleErrorInQueryFetcher";

export const GETDETAILSTVSHOW = "getDetailsAboutTvShow";
export const ERRORDETAILS = "handleErrorInDetailsFetcher";

export const LOADING = "activeLoader";
export const STOPLOADING = "stopLoader";



// WEBPACK FOOTER //
// ./src/states/types.js